<template>
    <div
        id="patient-photos"
        class="px-4 py-4 main-container sm:px-6"
    >
        <div class="h-full">
            <div class="mt-5 scrollable">
                <div class="grid grid-cols-3 mt-5">
                    <patient-photo
                        class="col-span-3 m-auto sm:col-span-1"
                        v-for="photo in this.patient.photos"
                        @gallery="openGallery"
                        :photo="photo"
                        :key="photo.id"
                    ></patient-photo>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import store from "../../../store";
import { mapState } from "vuex";

import PatientPhoto from "./PatientPhoto";
import PhotoGallery from "./PhotoGallery";

export default {
    components: {
        PatientPhoto
    },
    computed: {
        ...mapState("patient", ["patient"])
    },
    methods: {
        openGallery(id) {
            $("#patient-photos").insertAdjacentHTML(
                "beforeend",
                `<div id="gallery"></div>`
            );
            const index = _.findIndex(
                this.patient.photos,
                photo => photo.id == id
            );
            const gallery = Vue.extend(PhotoGallery);
            const vm = new gallery({
                store,
                propsData: {
                    index: index,
                    photos: this.patient.photos
                }
            }).$mount("#gallery");
        }
    }
};
</script>
